// extracted by mini-css-extract-plugin
export default {"link":"styles-module__link__src-labstep-web-core-Link-Button-_PUId5"};